import { TaskType } from '../enums/task.enum';
import { ContainerType } from '../enums/container-type.enum';

export enum ProtocolFieldType {
  Checkbox = 'checkbox',
  Switch = 'switch',
  Radio = 'radio',
  Text = 'text',
  TextArea = 'text-area',
  Date = 'date',
  Phone = 'phone',
  Select = 'select',
  Paragraph = 'paragraph',
}

export interface ProtocolValidationRule {
  logic: Record<string, unknown>;
  message?: string;
}

export interface ProtocolSelectItem {
  value: string;
  label?: string;
}

export interface ProtocolCustomField {
  type: ProtocolFieldType;
  label: string;
  description: string;
  placeholder: string;
  key: string;
  helperText: string;
  errorText?: string;
  hide?: boolean | Array<Record<string, unknown>>;
  validation?: ProtocolValidationRule[];
  options?: ProtocolSelectItem[];
}

export interface ProtocolCustomForm {
  title: string;
  description: string;
  defaults: Record<string, unknown>;
  fields: ProtocolCustomField[];
}

export enum ProtocolStatus {
  Draft = 'draft',
  Published = 'published',
  Archived = 'archived'
}

export interface ReaderTaskConfig {
  adjudication: boolean;
  longitudinal: boolean;
}

export interface ProtocolParentRef {
  id: string
  type: ContainerType
}

export interface ProtocolESignatureConfig {
  required: boolean;
  reasons: string[];
}

export interface Protocol {
  _id: string;
  label: string;
  form: ProtocolCustomForm;
  protocol_config: ReaderTaskConfig;
  created: string;
  modified?: string;
  replaced?: string;
  version: number;
  status: ProtocolStatus;
  parent_ref: ProtocolParentRef;
  task_type: TaskType;
  completion_tags: string[];
  notes?: string;
  modified_by?: string;
  esignature_config?: ProtocolESignatureConfig;
}

export interface ProtocolInput {
  label: string;
  group_id: string;
  protocol_config: ReaderTaskConfig;
  form?: ProtocolCustomForm;
  task_type: TaskType;
  completion_tags?: string[];
  notes?: string;
  esignature_config?: ProtocolESignatureConfig;
}

export interface ProtocolModify {
  form?: ProtocolCustomForm;
  protocol_config?: ReaderTaskConfig;
  completion_tags?: string[];
  notes?: string;
}
